import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { useTranslation } from 'react-i18next';

function ImageSectionWhat() {
  const { t } = useTranslation();

  const imageSectionItems: IImageWithTextSection[] = [
    {
      title: t('landing.imageSection.0.title'),
      description: t('landing.imageSection.0.description'),
      imageWidth: 271,
      imgSrc: 'https://cdn140.picsart.com/87356308998475406296.png',
      imgAlt: ' color wheel meaning',
      imageRight: true,
    },
    {
      title: t('landing.imageSection.1.title'),
      description: t('landing.imageSection.1.description'),
      imageWidth: 249,
      imgSrc: 'https://cdn140.picsart.com/70889338218832574724.png',
      imgAlt: 'understanding hue, saturation & lightness (HSL)',
    },
  ];

  return (
    <>
      {imageSectionItems.map((props, index) => (
        <ImageWithTextSection {...props} key={index} />
      ))}
    </>
  );
}

export default ImageSectionWhat;
